import React, { useState } from 'react';
import Menu from '../Menu'; // Assuming you have a Menu component

const LoginForClient = () => {
  const [merchantName, setMerchantName] = useState("M4");
  const [key, setKey] = useState("key4");
  const [posName, setPosName] = useState("7");
  const [msg, setMsg] = useState("Test connection");

  const handleLogin = () => {
    console.log("Login functionality - WebSocket removed");
    const data = {
      Action: "login",
      MerchantName: merchantName,
      Key: key,
      PosName: posName,
      Msg: msg,
    };
    console.log("Login data:", data);
  };

  const clearLog = () => console.log("Clear log - WebSocket removed");

  return (
    <>
      <Menu /> {/* Sidebar menu included */}
      <div className="content-wrapper" style={{ padding: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div
            style={{
              backgroundColor: 'var(--surface)',
              padding: '2rem',
              borderRadius: '8px',
              width: '48%',
            }}
          >
            <h4 style={{ color: 'var(--text)' }}>Login to WebSocket</h4>
            <div className="form-group">
              <label style={{ color: 'var(--text)' }}>Merchant Name</label>
              <input
                type="text"
                className="form-control"
                value={merchantName}
                onChange={(e) => setMerchantName(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label style={{ color: 'var(--text)' }}>Key</label>
              <input
                type="text"
                className="form-control"
                value={key}
                onChange={(e) => setKey(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label style={{ color: 'var(--text)' }}>POS Name</label>
              <input
                type="text"
                className="form-control"
                value={posName}
                onChange={(e) => setPosName(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label style={{ color: 'var(--text)' }}>Message</label>
              <input
                type="text"
                className="form-control"
                value={msg}
                onChange={(e) => setMsg(e.target.value)}
              />
            </div>

            <button className="btn btn-primary" onClick={handleLogin}>
              Login
            </button>
          </div>

          {/* Message Log Box */}
          <div
            style={{
              backgroundColor: 'var(--surface)',
              padding: '2rem',
              borderRadius: '8px',
              width: '48%',
            }}
          >
            <h4 style={{ color: 'var(--text)' }}>Message Log</h4>
            <ul style={{ maxHeight: '400px', overflowY: 'scroll', color: 'var(--text)' }}>
              <li style={{ color: 'var(--text)' }}>
                <strong style={{ color: 'var(--text)' }}>Status:</strong>{' '}
                <pre style={{ color: 'var(--text)' }}>WebSocket functionality has been removed</pre>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginForClient;
